import { Fragment, useMemo, useState } from "react";
import { ColumnDef } from "@tanstack/react-table";
import moment from "moment";

import DataTable from "../../../../components/dataTable/DataTable";
import { AdvancedPaymentEntriesColumns } from "../../../../components/dataTable/AdvancedPaymentEntriesColumn";
import ActionPromptModal from "../../../../components/modals/ActionPromptModal";
import { ActionPromptEnum } from "../../../../interfaces/enums";

interface Props {
    entries: IOrganisationAdvancedPaymentEntries[]
    size: number
    count: number
    loading: boolean
    pageIndex: number
    reference: string
    setPageIndex: (index: number) => void
    dateRange: { start_date: string; end_date: string }
}

const AdvancedPaymentEntries = ({ entries, size, count, loading, pageIndex, reference, setPageIndex, dateRange }: Props) => {

    const [refundAdvancedPaymentRender, setRefundAdvancedPaymentRender] = useState(false);
    const closeRefundAdvancedPaymentRender = () => setRefundAdvancedPaymentRender(false);
    const refundAdvancedPaymentModal = refundAdvancedPaymentRender ?
        <ActionPromptModal onchange={closeRefundAdvancedPaymentRender} type={ActionPromptEnum.REFUND_ADVANCED_PAYMENT_REQUEST} props={reference} /> : null;


    const columns: ColumnDef<IOrganisationAdvancedPaymentEntries, string>[] = useMemo(() => [...AdvancedPaymentEntriesColumns], []);

    const formattedDateRange = useMemo(() => {
        if (!dateRange?.start_date || !dateRange?.end_date) return "";
        const formatDate = (value: string) => moment(value).format("Do/MMM/YYYY").toUpperCase();
        return `ADVANCE PAYMENT ENTRIES FROM ${formatDate(dateRange.start_date)} - ${formatDate(dateRange.end_date)}`;
    }, [dateRange.end_date, dateRange.start_date]);

    return (
        <Fragment>
            {refundAdvancedPaymentModal}
            <div className="row">
                <div className="col-md-12">
                    <div className="card card-body">
                        <h5 className="card-title">Advanced Payment Entries</h5>
                        {(entries && entries.length > 0) &&
                            <div className="d-flex w-full justify-content-end">
                            <button className="btn btn-md btn-outline-primary px-4"
                                onClick={() => setRefundAdvancedPaymentRender(true)}
                            >
                                Refund
                            </button>
                        </div>
                        }
                        <DataTable columns={columns} data={entries} pageIndex={pageIndex} size={size}
                            count={count} loadingState={loading}
                            setPageIndex={setPageIndex}
                            footerContent={formattedDateRange ? (
                                <div className="text-center fw-bold text-uppercase mt-3">
                                    {formattedDateRange}
                                </div>
                            ) : undefined}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default AdvancedPaymentEntries;
